import Sticky from './Sticky';
export { Props } from './Sticky';
export default Sticky;

export {
    Sticky
};
